import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoginProvider } from '../../core/LoginProvider'

export enum LoginStatus {
	Unknown,
	LoggedIn,
	NotLoggedIn,
}

export interface UserSocialProfile {
	firstName: string
	lastName: string
	name: string
	picture: string
	original: any
	core_registration_date?: number
}

export interface UserInfo {
	user_ext_id: string
	email: string
	profile: UserSocialProfile
	user_id: number
}

interface UserState {
	user: UserInfo | undefined
	loggedIn: LoginStatus
	provider: LoginProvider
	user_id: number | undefined
}

const initialState: UserState = {
	user_id: undefined,
	user: undefined,
	loggedIn: LoginStatus.Unknown,
	provider: LoginProvider.NONE,
}

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setProfile: (state, action: PayloadAction<UserInfo>) => {
			state.user = action.payload
			state.loggedIn = LoginStatus.LoggedIn
		},
		setNotLoggedIn: (state) => {
			state.loggedIn = LoginStatus.NotLoggedIn
			state.user = undefined
		},
		forgetUser: (state) => {
			Object.assign(state, initialState)
		},
		setUserId: (state, action: PayloadAction<number>) => {
			state.user_id = action.payload
		},
	},
})

export const { setProfile, setNotLoggedIn, forgetUser } = userSlice.actions

export default userSlice.reducer
